<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img
              src="assets/images/logopequexx.png"
              alt=""
              height="50"
              width="50"
            />
          </span>
          <span class="logo-lg">
            <img src="assets/images/logoxx.png" alt="" height="90" />
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img
              src="assets/images/logopequexxx.png"
              alt=""
              height="50"
              width="50"
            />
          </span>
          <span class="logo-lg">
            <img src="assets/images/logoxxx.png" alt="" height="90" />
          </span>
        </a>
      </div>

      <button
        type="button"
        class="btn btn-sm px-3 font-size-16 header-item"
        id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)"
      >
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <!-- <div class="app-search d-none d-lg-block">
                <div class="position-relative">

                    <input _ngcontent-mag-c105="" type="text" placeholder="Search..." class="form-control">
                    <button _ngcontent-mag-c105="" type="button" class="btn btn-primary">
                        <i _ngcontent-mag-c105="" class="bx bx-search-alt align-middle"></i>
                    </button>

                </div>
            </div> -->
    </div>

    <div class="d-flex">
      <div class="dropdown d-none d-sm-inline-block">
        <button type="button" class="btn header-item" id="mode-setting-btn">
          @if(layoutMode == 'light'){
          <ng-container>
            <i-feather
              name="moon"
              class="feather-grid icon-lg"
              (click)="changeMode('dark')"
            ></i-feather>
          </ng-container>
          } @if(layoutMode == 'dark'){
          <ng-container>
            <i-feather
              name="sun"
              class="feather-grid icon-lg"
              (click)="changeMode('light')"
            ></i-feather> </ng-container
          >}
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button
          type="button"
          class="btn header-item topbar-light bg-light-subtle border-start border-end"
          id="page-header-user-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          <img
            class="rounded-circle header-profile-user"
            src="assets/images/users/avatar-1.jpg"
            alt="Header Avatar"
          />
          <span class="d-none d-xl-inline-block ms-1 fw-medium"
            >Nombre Paciente</span
          >
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" routerLink="/apps/profile"
            ><i class="mdi mdi-face-man font-size-16 align-middle me-1"></i>
            Perfil</a
          >

          <div class="dropdown-divider"></div>
          <a
            class="dropdown-item"
            href="javascript: void(0);"
            (click)="logout()"
            ><i
              class="mdi mdi-logout text-muted font-size-16 align-middle me-1"
            ></i>
            <span class="align-middle" key="t-logout">{{
              "MENUITEMS.AUTHENTICATION.LIST.LOGOUT" | translate
            }}</span></a
          >
        </div>
      </div>
    </div>
  </div>
</header>
